// import { apiClient } from "./api";

// export const jobService = {
//   createJob: (jobData) => apiClient.post("/jobs/create", { job: jobData }),

//   getAllJobs: (store_id) => apiClient.get(`/jobs/store/${store_id}`),

//   getJobById: (job_id) => apiClient.get(`/jobs/${job_id}`),

//   updateJob: (job_id, jobData) =>
//     apiClient.put(`/jobs/${job_id}`, { job: jobData }),

//   deleteJob: (job_id) => apiClient.delete(`/jobs/${job_id}`),

//   createHiringStages: (store_id, job_id, stages) =>
//     apiClient.post("/hiring-stages/create", { store_id, job_id, stages }),

//   getStagesByJob: (job_id) => apiClient.get(`/hiring-stages/job/${job_id}`),

//   updateStage: (stage_id, stageData) =>
//     apiClient.put(`/hiring-stages/${stage_id}`, stageData),

//   deleteStage: (stage_id) => apiClient.delete(`/hiring-stages/${stage_id}`),

//   createScreeningQuestions: (store_id, job_id, stage_id, questions) =>
//     apiClient.post("/screening-questions/create", {
//       store_id,
//       job_id,
//       stage_id,
//       questions,
//     }),

//   getQuestionsByStage: (stage_id) =>
//     apiClient.get(`/screening-questions/stage/${stage_id}`),

//   updateQuestion: (question_id, questionData) =>
//     apiClient.put(`/screening-questions/${question_id}`, questionData),

//   deleteQuestion: (question_id) =>
//     apiClient.delete(`/screening-questions/${question_id}`),
// };

// // Template APIs
// export const templateService = {
//   createTemplate: (templateData) =>
//     apiClient.post("/job-templates", { template: templateData }),
//   getTemplatesByStore: (store_id) =>
//     apiClient.get(`/job-templates/store/${store_id}`),
//   getTemplateById: (template_id) =>
//     apiClient.get(`/job-templates/${template_id}`),
//   updateTemplate: (template_id, templateData) =>
//     apiClient.put(`/job-templates/${template_id}`, { template: templateData }),
//   deleteTemplate: (template_id) =>
//     apiClient.delete(`/job-templates/${template_id}`),
// };

// // Create job from template
// export const createJobFromTemplate = (template_id, jobOverrides, stages) =>
//   apiClient.post("/jobs/create-from-template", {
//     template_id,
//     jobOverrides,
//     stages,
//   });

// // Get screening questions for a job
// export const getScreeningQuestionsForJob = (job_id) =>
//   apiClient.get(`/jobs/${job_id}/screening-questions`);
import { apiClient } from "./api";

export const jobService = {
  createJob: (jobData) => apiClient.post("/jobs/create", { job: jobData }),

  getAllJobs: (store_id) => apiClient.get(`/jobs/store/${store_id}`),

  getJobById: (job_id) => apiClient.get(`/jobs/${job_id}`),

  updateJob: (job_id, jobData) =>
    apiClient.put(`/jobs/${job_id}`, { job: jobData }),

  // Open or close a job. Closing stops new candidates arriving; it does not
  // touch anyone already in the pipeline.
  setJobStatus: (job_id, status) =>
    apiClient.patch(`/jobs/${job_id}/status`, { status }),

  // What a delete would destroy. Read-only — the confirmation needs real
  // numbers, because "this cannot be undone" is not information.
  previewDeleteJob: (job_id) => apiClient.get(`/jobs/${job_id}/delete-preview`),

  // Empty the pipeline, keep the job. Rounds, questions and rubric survive —
  // this is "start again with the same role" after a bad import.
  clearJobCandidates: (job_id) => apiClient.delete(`/jobs/${job_id}/candidates`),

  // The job, its pipeline, and candidates who were only in this job. Never the
  // template it was created from.
  deleteJob: (job_id) => apiClient.delete(`/jobs/${job_id}`),

  createHiringStages: (store_id, job_id, stages) =>
    apiClient.post("/hiring-stages/create", { store_id, job_id, stages }),

  getStagesByJob: (job_id) => apiClient.get(`/hiring-stages/job/${job_id}`),

  updateStage: (stage_id, stageData) =>
    apiClient.put(`/hiring-stages/${stage_id}`, stageData),

  // ── Saving an existing job's rounds ─────────────────────────────────────
  //
  // Send the COMPLETE desired list. A round carrying an `id` is updated in
  // place; one without is created; one whose id is absent from the list is
  // removed. All in one transaction on the server.
  //
  // Use this and never delete-then-recreate. Recreating hands every round a
  // new id, and `applications.current_stage_id`, the interview rubric, the
  // recorded sessions and the movement history all point at the old ones — so
  // renaming a round used to make every candidate on the job vanish from the
  // pipeline and detach the rubric that "Send link" needs.
  //
  // Refuses with 409 and a per-round breakdown if a round being removed still
  // has candidates or recorded interviews on it. Nothing is written when it
  // refuses.
  saveJobStages: (job_id, stages) =>
    apiClient.put(`/jobs/${job_id}/stages`, { stages }),

  deleteStage: (stage_id) => apiClient.delete(`/hiring-stages/${stage_id}`),
  createJobFromTemplate: (template_id, jobOverrides, stages) =>
    apiClient.post("/jobs/create-from-template", {
      template_id,
      jobOverrides,
      stages,
    }),
  getScreeningQuestionsForJob: (job_id) =>
    apiClient.get(`/jobs/${job_id}/screening-questions`),
};

// ── The JD document ─────────────────────────────────────────────────────────
//
// Upload and save are two calls, deliberately.
//
// The template save and the job save are both JSON, through handlers every
// other screen in this module already uses. Teaching either of them to accept a
// multipart body would give one save two code paths, and the multipart one —
// used by this screen alone — is the one that would rot.
//
// So this puts the file in blob storage and hands back a URL, which the form
// then includes in the ordinary JSON save it was already making. It also means
// "replace the JD and change nothing else" and "attach the same JD to a second
// job" need no new endpoint, because the URL is just a value.
//
// NOTHING IS ATTACHED UNTIL THE FORM IS SAVED. An abandoned form leaves an
// unreferenced blob rather than a half-attached document — the cheaper of the
// two failures, and the only one that cannot confuse somebody reading the job.
export const jdService = {
  // `file` is a File from an <input type="file">. The Content-Type header is
  // deliberately not set here: the axios instance strips its JSON default for
  // any FormData body, because only the browser knows the multipart boundary.
  // See the interceptor in ./api.js — getting this wrong fails as "no file was
  // uploaded", which reads like the client sent nothing.
  upload: (file) => {
    const form = new FormData();
    form.append("jd", file);
    return apiClient.post("/jd-documents", form);
  },
};

// Template APIs
export const templateService = {
  createTemplate: (templateData) =>
    apiClient.post("/job-templates", { template: templateData }),
  getTemplatesByStore: (store_id) =>
    apiClient.get(`/job-templates/store/${store_id}`),
  getTemplateById: (template_id) =>
    apiClient.get(`/job-templates/${template_id}`),
  updateTemplate: (template_id, templateData) =>
    apiClient.put(`/job-templates/${template_id}`, { template: templateData }),
  deleteTemplate: (template_id) =>
    apiClient.delete(`/job-templates/${template_id}`),
};

// Create job from template

// Get screening questions for a job (from template)
// export const getScreeningQuestionsForJob = (job_id) =>
//   apiClient.get(`/jobs/${job_id}/screening-questions`);
